import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "user-profile-info" }
const _hoisted_2 = { class: "header-box" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-50 text-cyan-800" }
const _hoisted_5 = { class: "mt-1 text-sm text-slate-500" }
const _hoisted_6 = { class: "w-full sm:w-auto" }
const _hoisted_7 = {
  class: "boxes",
  "aria-label": "بخش‌های پروفایل کاربر"
}
const _hoisted_8 = ["onClick", "aria-current", "onKeydown"]
const _hoisted_9 = { class: "profile-content" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_ProfileInfoComponent = _resolveComponent("ProfileInfoComponent")!
  const _component_AccountChargeBoxComponent = _resolveComponent("AccountChargeBoxComponent")!
  const _component_UserStatementComponent = _resolveComponent("UserStatementComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_v_icon, { size: "22" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-account-box-outline", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "title" }, "پروفایل کاربر", -1)),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.getUserAcceptedAuth?.firstName || _ctx.getUserInfo.name || 'اطلاعات حساب و فعالیت کاربر'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ButtonComponent, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
          class: "min-w-[150px] max-w-[150px]",
          text: 'بازگشت',
          status: 'primary'
        })
      ])
    ]),
    _createElementVNode("nav", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boxes, (box, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          onClick: ($event: any) => (_ctx.handleBox(box)),
          "aria-current": _ctx.selectedBox === box.value ? 'page' : undefined,
          class: _normalizeClass([_ctx.selectedBox === box.value ? 'box--active' : '', "box"]),
          role: "button",
          tabindex: "0",
          onKeydown: [
            _withKeys(($event: any) => (_ctx.handleBox(box)), ["enter"]),
            _withKeys(_withModifiers(($event: any) => (_ctx.handleBox(box)), ["prevent"]), ["space"])
          ]
        }, [
          _createVNode(_component_v_icon, { size: "19" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(box.icon), 1)
            ]),
            _: 2
          }, 1024),
          _createElementVNode("span", null, _toDisplayString(box.title), 1)
        ], 42, _hoisted_8))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.selectedBox === 'info')
        ? (_openBlock(), _createBlock(_component_ProfileInfoComponent, {
            key: 0,
            user: _ctx.getUserAcceptedAuth
          }, null, 8, ["user"]))
        : _createCommentVNode("", true),
      (_ctx.selectedBox === 'wallets')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_AccountChargeBoxComponent, {
              user: _ctx.getUserInfo,
              onChargeAccount: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleChargeAndDechargeWalletAccount($event))),
              onUserCashout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleUserCashout($event)))
            }, null, 8, ["user"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedBox === 'statement')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_UserStatementComponent, {
              logs: _ctx.getUserStatement.logs,
              summary: _ctx.getUserStatement.summary,
              pagination: _ctx.getUserStatement.pagination,
              user: _ctx.getUserStatement.user,
              loading: _ctx.getLoadingPanel,
              onPageChange: _ctx.handleStatementPageChange,
              onFilterChange: _ctx.handleStatementFilterChange,
              onRefresh: _ctx.handleStatementRefresh,
              onExport: _ctx.handleStatementExport
            }, null, 8, ["logs", "summary", "pagination", "user", "loading", "onPageChange", "onFilterChange", "onRefresh", "onExport"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}